export class AxPortletExpandable {

    Init() {
        $('.ax-portlet.ax-portlet--expandable').each((i, x) => {
            let $portlet = $(x);
            $portlet.find('button[data-dismiss="portlet"]').each((i2, button) => {
                $(button).click(x => {
                    let options = {
                        detail: {
                            elem: button
                        },
                        bubbles: true,
                        cancelable: true,
                        composed: false
                    };

                    let onOpen = new CustomEvent('ax-portlet--open', options);
                    let onClose = new CustomEvent('ax-portlet--close', options);

                    $portlet.toggleClass('active');

                    if ($portlet.hasClass('active')) {
                        button.dispatchEvent(onOpen);
                    }
                    if (!$portlet.hasClass('active')) {
                        button.dispatchEvent(onClose);
                    }
                });
            });
        });

    }

    OnOpen(selector: string, callback: (e: CustomEvent, elem: HTMLElement) => void) {
        let div_list = document.querySelectorAll(selector);
        div_list.forEach(div => {
            div.addEventListener("ax-portlet--open", (event: CustomEvent) => {
                callback(event, event.detail.elem);
            });
        });

    }

    OnClose(selector: string, callback: (e: CustomEvent, elem: HTMLElement) => void) {
        document.querySelector(selector).addEventListener("ax-portlet--close", (event: CustomEvent) => {
            callback(event, event.detail.elem);
        });
    }
}
